import { render, staticRenderFns } from "./SemenCollection.vue?vue&type=template&id=348db488&scoped=true&"
import script from "./SemenCollection.vue?vue&type=script&lang=js&"
export * from "./SemenCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348db488",
  null
  
)

export default component.exports